var _path, _path2, _path3, _path4, _g, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _g5, _path9, _g6, _path10, _g7, _path11, _g8, _path12, _g9, _path13, _g10, _path14, _g11, _path15, _g12, _path16, _g13, _path17, _g14, _path18, _g15, _path19, _g16, _path20, _g17, _path21, _g18, _path22, _g19, _path23, _g20, _path24, _g21, _path25, _g22, _path26, _g23, _path27, _g24, _path28, _g25, _path29, _g26, _path30, _g27, _path31, _g28, _path32, _g29, _path33, _g30, _path34, _g31, _path35, _g32, _path36, _g33, _path37, _g34, _path38, _g35, _path39, _g36, _path40, _g37, _path41;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSydney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 41,
    viewBox: "0 0 119 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.386 9.19371V9.81679H46.0117V8.58618H46.386V8.80328H50.1867V8.58618H50.561V9.81679H50.1867V9.19371H48.6261V13.6589H49.4093V13.9474H47.1634V13.6589H47.9408V9.19371H46.386Z",
    fill: "#004485"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3001 11.5149V13.6589H52.8817V13.9474H51.0275V13.6589H51.6148V9.09115H51.0275V8.80322H52.8817V9.09115H52.3001V11.1648H55.2197V9.09115H54.6381V8.80322H56.4924V9.09115H55.8992V13.6589H56.4924V13.9474H54.6381V13.6589H55.2197V11.5149H52.3001Z",
    fill: "#004485"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 9.09121V8.80328H60.2526V8.58618H60.6096V9.82485H60.2641V9.16204H58.4156V11.1562H59.8898V10.5729L60.2468 10.5648V12.1001L59.8898 12.1081V11.5081H58.4156V13.5973H60.3332V12.9109H60.6902V13.9474H57.1429V13.6589H57.7303V9.09121H57.1429Z",
    fill: "#004485"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.3897 9.09175H67.8052V12.0609C67.8052 12.8947 67.5086 13.4326 66.8631 13.7838C66.5348 13.9549 66.1605 14.0476 65.7787 14.0476C64.6501 14.0476 63.8156 13.2995 63.8156 12.2785V9.09117H63.2311V8.80209H65.086V9.09117H64.5015V12.0367C64.5015 12.9799 65.0537 13.5955 65.9198 13.5955C66.8078 13.5955 67.4073 12.9638 67.4073 12.0286V9.09059H66.8245V8.80151H68.3903L68.3897 9.09175Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.5548 13.9473H68.9827V13.6582H69.5701V9.38763L69.3628 9.09106H68.8215V8.80371H69.9559L72.8064 12.7161V9.09106H72.2133V8.80371H73.7796V9.09106H73.198V14.0331H72.9561L69.9617 9.918V13.6582H70.5548V13.9473Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.3499 9.09115V8.80322H76.2041V9.09115H75.6167V13.6589H76.2041V13.9474H74.3499V13.6589H74.9315V9.09115H74.3499Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.5997 8.80371V9.09106H77.8626L79.3771 12.9188L80.8743 9.09106H80.3561V8.80371H81.692V9.09106H81.3005L79.3541 14.0797H79.0892L77.1255 9.09106H76.6648V8.80371H78.5997Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.1583 9.09121V8.80328H85.268V8.58618H85.625V9.82485H85.2737V9.16204H83.4252V11.1562H84.8994V10.5729L85.2564 10.5648V12.1001L84.8994 12.1081V11.5081H83.4252V13.5973H85.3428V12.9109H85.7056V13.9474H82.1583V13.6589H82.7399V9.09121H82.1583Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90.9575 13.9474H90.2953C89.8357 13.9474 89.7494 13.9002 89.4914 13.4878L88.3305 11.6405H87.7223V13.6583H88.3068V13.9468H86.4526V13.6589H87.0365V9.09173H86.4526V8.80322H88.619C89.3751 8.80322 89.8029 9.01456 90.0367 9.49713C90.1386 9.70732 90.1939 9.9417 90.1939 10.191C90.1939 10.9471 89.7724 11.4309 89.0244 11.5397L90.1461 13.2696C90.3327 13.5581 90.4582 13.6514 90.6535 13.6514H90.9569V13.9474H90.9575ZM87.7229 11.2817H88.4704C89.0629 11.2817 89.477 10.8458 89.477 10.2054C89.477 9.53629 89.1102 9.16141 88.4548 9.16141H87.7229V11.2817Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.9538 14.0175H91.587V12.6147H91.9538V13.2297C92.4295 13.5493 92.6391 13.6282 92.9823 13.6282C93.606 13.6282 94.0263 13.3 94.0263 12.8099C94.0263 12.3654 93.7229 12.0377 92.8821 11.6006C91.8991 11.0858 91.5651 10.6965 91.5651 10.0579C91.5651 9.28626 92.2199 8.70868 93.1004 8.70868C93.4896 8.70868 93.7776 8.77893 94.0263 8.9275V8.64648H94.3851V9.97902H94.0263V9.42677C93.6302 9.1613 93.4344 9.08356 93.1223 9.08356C92.593 9.08356 92.2504 9.40316 92.2504 9.88573C92.2504 10.2837 92.4767 10.51 93.4505 11.0714C94.4243 11.6329 94.7047 11.9749 94.7047 12.6142C94.7047 13.425 94.0356 14.0475 93.1545 14.0475C92.6633 14.0475 92.3437 13.9467 91.9544 13.6973V14.0175H91.9538Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.4204 9.09115V8.80322H97.2747V9.09115H96.6873V13.6589H97.2747V13.9474H95.4204V13.6589H96.002V9.09115H95.4204Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1557 9.19371V9.81679H97.7814V8.58618H98.1557V8.80328H101.956V8.58618H102.331V9.81679H101.956V9.19371H100.396V13.6589H101.179V13.9474H98.9332V13.6589H99.7106V9.19371H98.1557Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.217 9.09115H102.768V8.80322H104.692V9.09115H103.983L105.319 11.1343L106.563 9.09115H105.849V8.80322H107.41V9.09115H107.007L105.509 11.5311V13.6589H106.103V13.9474H104.248V13.6589H104.83V11.5783L103.217 9.09115Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.419 11.3826C109.419 9.91705 110.558 8.70947 111.936 8.70947C113.292 8.70947 114.431 9.92511 114.431 11.3751C114.431 12.8251 113.292 14.0477 111.936 14.0477C110.565 14.0483 109.419 12.8326 109.419 11.3826ZM110.191 11.3757C110.191 12.6927 110.924 13.6434 111.936 13.6434C112.933 13.6434 113.66 12.6846 113.66 11.3757C113.66 10.0662 112.933 9.11545 111.945 9.11545C110.924 9.11545 110.191 10.0501 110.191 11.3757Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.913 9.09121V8.80328H118.023V8.58618H118.38V9.82485H118.029V9.16204H116.18V11.1562H117.654V10.5729L118.011 10.5648V12.1001L117.654 12.1081V11.5081H116.18V13.6589H116.767V13.9474H114.913V13.6589H115.495V9.09121H114.913Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9793 30.5972H46.0136V26.9002H46.9793V28.5224C48.2323 29.3649 48.7875 29.5705 49.6904 29.5705C51.3339 29.5705 52.443 28.7078 52.443 27.4133C52.443 26.2426 51.642 25.3799 49.4238 24.2294C46.8359 22.8744 45.9525 21.8465 45.9525 20.154C45.9525 18.1201 47.6784 16.6004 49.9985 16.6004C51.0253 16.6004 51.786 16.7847 52.443 17.1757V16.4363H53.388V19.9479H52.443V18.4898C51.3955 17.7924 50.8819 17.5874 50.0601 17.5874C48.6631 17.5874 47.7607 18.4287 47.7607 19.702C47.7607 20.75 48.355 21.3507 50.9222 22.8335C53.4911 24.3123 54.2299 25.2164 54.2299 26.9008C54.2299 29.0366 52.4626 30.6801 50.1425 30.6801C48.8485 30.6801 48.006 30.4129 46.9793 29.7565V30.5972Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.7898 17.6063H54.5978V16.8462H59.6711V17.6063H57.8053L61.3353 22.9981L64.6004 17.6063H62.7289V16.8462H66.8405V17.6063H65.7694L61.8306 24.0456V29.6533H63.3911V30.4123H58.5021V29.6533H60.0396V24.1688L55.7898 17.6063Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask14_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M67.8657 30.4123V29.6527H69.4061V17.6063H67.8657V16.8462H73.9249C77.6219 16.8462 80.6417 19.8861 80.6417 23.6143C80.6417 27.4132 77.6841 30.4123 73.9041 30.4123H67.8657ZM71.2143 29.3849H73.6795C76.4926 29.3849 78.629 26.9001 78.6077 23.6356C78.6077 20.4614 76.431 17.8937 73.7204 17.8937H71.2143V29.3849Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.527 30.4122H81.3751V29.6521H82.9414V18.3871L82.3829 17.6074H80.9662V16.8467H83.9434L91.4642 27.1672V17.6074H89.9036V16.8467H94.0325V17.6074H92.4892V30.6385H91.8557L83.9665 19.7836V29.6521H85.527V30.4122Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask16_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.426 17.6061V16.8459H103.62V16.2712H104.565V19.5375H103.644V17.7904H98.7718V23.0589H102.653V21.515L103.597 21.4943V25.5437L102.653 25.5644V23.9826H98.7718V29.4878H103.828V27.6802H104.772V30.412H95.426V29.653H96.9636V17.6061H95.426Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.335 17.6063H106.143V16.8462H111.216V17.6063H109.35L112.88 22.9981L116.145 17.6063H114.28V16.8462H118.386V17.6063H117.32L113.376 24.0456V29.6533H114.936V30.4123H110.047V29.6533H111.59V24.1688L107.335 17.6063Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.3867 5.8476V15.374C38.3867 26.9217 30.5228 38.7821 19.1887 41.0009C8.25894 38.9261 0.000549316 26.9212 0.000549316 15.374V2.56348C0.000549316 2.56348 9.57651 -0.000244141 19.1922 -0.000244141C30.365 -0.000244141 38.3867 2.56348 38.3867 2.56348V5.8476Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1922 37.9954C28.3938 37.9856 35.531 29.4496 35.5322 20.0493V3.86711L35.2921 3.79397C35.2921 3.79397 27.0008 1.22276 19.1887 1.22046C11.3789 1.22276 3.10039 3.79052 3.08657 3.79397L2.84644 3.86711V20.0499C2.84759 29.4502 9.98478 37.9862 19.1864 37.996",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask20_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9078 36.8093V30.4444H30.1711C30.5966 30.4444 30.975 30.6557 31.2088 30.9799C32.9248 28.6909 34.1186 25.94 34.6052 23.0049H22.9078V16.884C21.6783 16.8219 20.4275 16.7844 19.1894 16.7844C17.9537 16.7844 16.7046 16.8213 15.4775 16.8829V23.0049H3.77197C4.25973 25.9423 5.45521 28.6938 7.17357 30.9828C7.40564 30.6574 7.78571 30.4438 8.2153 30.4438H15.4775V36.8116C16.6643 37.1382 17.903 37.3178 19.1866 37.3178V37.3708H19.1923V37.3178C20.4771 37.3184 21.7192 37.1387 22.9078 36.8093Z",
    fill: "#004485"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6187 27.3183L25.9764 26.7546L27.6262 26.1649L26.8649 24.6014L28.452 25.3541L29.0146 23.7129L29.6054 25.3621L31.1643 24.6014L30.4122 26.1879L32.0528 26.7546L30.4013 27.3431L31.1643 28.9043L29.5784 28.1522L29.0146 29.7951L28.4255 28.1435L26.8649 28.9043L27.6187 27.3183Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask22_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7598 27.3183L12.4016 26.7546L10.7523 26.1649L11.513 24.6014L9.92828 25.3541L9.36337 23.7129L8.77484 25.3621L7.21368 24.6014L7.96633 26.1879L6.32513 26.7546L7.979 27.3431L7.21368 28.9043L8.80075 28.1522L9.36337 29.7951L9.95132 28.1435L11.513 28.9043L10.7598 27.3183Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask23_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7964 33.5529L16.1541 32.9868L17.8045 32.3971L17.0438 30.8371L18.6262 31.5892L19.1934 29.9463L19.7831 31.5984L21.3397 30.8371L20.5893 32.4231L22.2305 32.9868L20.5801 33.5771L21.3397 35.1382L19.7572 34.3873L19.1934 36.0331L18.6038 34.3758L17.0438 35.1382L17.7964 33.5529Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.7952 21.5066L16.1541 20.9417L17.8045 20.3531L17.0461 18.7926L18.6274 19.544L19.1934 17.9011L19.7802 19.5538L21.3408 18.7926L20.5882 20.3767L22.2317 20.9417L20.5801 21.5319L21.3408 23.0931L19.7584 22.3421L19.1934 23.9833L18.6038 22.3329L17.0461 23.0931L17.7952 21.5066Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0442 24.2329H24.3561V24.7402H25.0442V24.2329Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask26_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0442 25.585H24.3561V26.09H25.0442V25.585Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0442 26.9326H24.3561V27.44H25.0442V26.9326Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask28_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0442 28.2837H24.3561V28.7876H25.0442V28.2837Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask29_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9279 23.923C20.8686 23.9144 20.8001 23.923 20.7385 23.923C20.04 23.923 19.5015 24.4626 19.5015 25.1502V29.229C19.7301 28.9595 20.0716 28.7885 20.4546 28.7885C20.5035 28.7885 23.0321 28.7902 23.9909 28.7902V23.923H20.9279ZM23.3056 27.9005H20.2789V27.4427H23.3056V27.9005ZM23.3056 26.6451H20.2789V26.1856H23.3056V26.6451ZM23.3056 25.3897H20.2789V24.9302H23.3056V25.3897Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0223 24.2329H13.3342V24.7402H14.0223V24.2329Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask31_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0223 25.585H13.3342V26.09H14.0223V25.585Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask32_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0223 26.9326H13.3342V27.44H14.0223V26.9326Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0223 28.2837H13.3342V28.7876H14.0223V28.2837Z",
    fill: "#FBB500"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask34_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3879 23.923V28.7902C15.3478 28.7902 17.8747 28.7885 17.9254 28.7885C18.3072 28.7885 18.6504 28.9595 18.8779 29.229V25.1502C18.8779 24.4626 18.34 23.923 17.6392 23.923C17.5781 23.923 17.509 23.9144 17.4514 23.923H14.3879ZM15.072 27.441H18.0993V27.8993H15.072V27.441ZM15.072 26.1862H18.0993V26.6457H15.072V26.1862ZM15.072 24.9319H18.0993V25.3915H15.072V24.9319Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask35_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1889 16.1071C25.9708 16.1082 33.1218 17.1949 34.8551 17.4742V4.36994C34.6219 4.30256 34.2257 4.18796 33.6924 4.04573C32.8027 3.80732 31.533 3.4906 30.0248 3.171C27.0056 2.53352 23.0206 1.89893 19.1889 1.89893C13.4378 1.89777 7.35438 3.32936 4.68355 4.04573C4.1503 4.18854 3.75411 4.30314 3.52319 4.36994V17.4736C5.25423 17.196 12.4087 16.1082 19.1889 16.1071Z",
    fill: "#D4002A"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_344_923",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 119,
    height: 41
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M118.385 0H0V41H118.385V0Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_344_923)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.1169 12.1787C25.8969 12.3716 25.5048 12.5806 24.8828 12.5582C24.6202 12.5472 24.4936 12.6227 24.4273 12.701C24.3893 12.754 24.3646 12.8196 24.3594 12.8334C24.3243 12.9624 24.3715 13.1006 24.4406 13.2095C24.5085 13.3051 24.4826 13.3667 24.3795 13.3909C24.2776 13.4179 24.1411 13.4202 23.8745 13.2912C23.7576 13.2348 23.7242 13.3068 23.7087 13.3609C23.6643 13.4916 23.749 13.6512 23.9235 13.7675C24.0127 13.8458 23.9972 13.9224 23.8567 13.9713C23.6223 14.0543 23.4109 13.9454 23.0672 13.7554C22.8644 13.6425 22.7084 13.6241 22.5719 13.7848C22.4947 13.8746 22.5017 13.9569 22.546 14.0036C22.6807 14.136 22.7614 14.4027 22.4268 14.823C22.3162 14.9618 22.1976 14.5771 22.0957 14.6226C21.639 14.8363 21.2641 14.557 21.1231 14.3646C21.092 14.3255 21.028 14.3134 20.9497 14.3646C20.7211 14.5173 20.2322 14.7701 20.0427 14.3284C20.0134 14.265 19.7444 14.4291 19.7479 14.303C19.7577 13.5723 20.3917 13.4358 20.6618 13.4122C20.7441 13.4035 20.7608 13.3638 20.7171 13.297C20.6088 13.1386 20.4781 12.9503 20.5495 12.7321C20.5996 12.5703 20.185 12.5328 20.356 12.4493C21.191 12.033 21.6574 12.8306 21.8026 12.9164C22.045 13.0557 23.1351 12.7004 23.2675 12.1096C23.2958 11.9938 23.0142 11.942 22.7332 11.8718C22.6813 11.8597 22.6531 11.7946 22.7458 11.7209C23.4075 11.2285 23.9373 10.5899 25.1333 10.4713C25.2784 10.4563 25.336 10.5766 25.3406 10.6354C25.3643 10.8208 25.412 11.0022 25.4921 11.1721C25.6654 11.5389 25.8727 11.7664 26.0829 11.9339C26.1866 12.0157 26.1745 12.1286 26.1169 12.1787ZM30.9063 10.4949C31.7828 10.4989 30.9207 11.221 30.8758 11.4324C30.8447 11.5861 30.9858 11.7243 31.1234 11.8044C31.2276 11.8585 31.2305 11.9253 31.1534 11.9944C31.0716 12.0658 30.9507 12.1309 30.6552 12.1372C30.5274 12.1384 30.5286 12.2196 30.5389 12.2749C30.5568 12.4096 30.7082 12.5127 30.9178 12.5374C31.0313 12.5668 31.0509 12.6428 30.9507 12.7494C30.7762 12.9308 30.5429 12.9308 30.1479 12.9175C29.7759 12.9043 29.4793 13.3557 29.6976 13.5441C29.8444 13.6707 30.1456 13.9518 29.8865 14.713C29.8041 14.944 29.6636 14.5023 29.545 14.572C29.2363 14.7551 28.9686 14.5242 28.8286 14.3577C28.7682 14.2869 28.714 14.2846 28.6737 14.3577C28.5493 14.5731 28.2251 14.9526 27.5704 14.5984C27.4276 14.5224 27.135 14.7827 27.1183 14.6946C27.0112 14.185 27.2732 13.8827 27.4955 13.7243C27.5174 13.7059 27.6038 13.5901 27.4586 13.5941C27.2364 13.5826 26.9674 13.5101 26.9369 13.2406C26.9323 13.183 26.6542 13.1962 26.6691 13.1191C26.7342 12.7442 27.5583 12.473 28.1261 12.8484C28.6063 13.1669 29.2098 12.0837 28.7762 11.5752C28.4629 11.2101 26.6288 12.2322 26.0046 10.9037C25.7541 10.3688 26.0685 9.91268 25.8134 9.87583C25.5589 9.83955 24.406 9.58963 23.1259 10.6193C20.9624 12.3595 18.6175 11.4116 18.0658 11.0235C17.98 10.9965 17.8948 11.0656 17.9322 11.1537C18.0203 11.3771 17.9823 11.5861 17.8746 11.7456C17.6495 12.0866 16.8721 12.4349 16.7344 12.4758C15.824 12.7419 15.9202 13.4404 16.0158 13.7496C16.044 13.8441 16.01 13.9005 15.9115 13.8832C15.6328 13.832 15.0702 13.661 14.8485 13.1133C14.8243 13.0505 14.7615 13.0482 14.6855 13.1018C14.3469 13.3425 14.4667 13.6938 14.5467 13.8504C14.5773 13.9114 14.56 13.9702 14.4799 13.9794C14.169 14.0168 13.9467 13.6552 13.6795 13.6805C13.505 13.6978 13.3012 13.832 13.1894 13.9091C13.1347 13.9437 13.1278 14.0318 13.1606 14.1314C13.501 15.1409 12.9424 15.1743 12.909 15.157C12.8681 15.1346 12.8917 14.9664 12.7288 14.9405C12.1817 14.971 12.0245 14.6134 11.9951 14.3497C11.9836 14.2639 11.9508 14.2345 11.892 14.2737C11.6847 14.4188 11.1734 14.7027 10.8526 14.2852C10.806 14.2247 10.6534 14.2875 10.5704 14.3232C10.5042 14.3514 10.5013 14.242 10.5042 14.208C10.5422 13.6327 10.9315 13.3736 11.1469 13.2728C11.2252 13.2365 11.2338 13.1939 11.1711 13.1473C10.9977 13.0183 10.6919 12.7407 10.7887 12.4384C10.8054 12.382 10.5336 12.2737 10.6015 12.2248C11.2304 11.7681 12.0395 12.5259 12.1425 12.6083C12.2508 12.6941 12.8226 12.7125 14.2818 11.8908C15.2101 11.3702 15.6962 10.9377 15.9605 10.6095C15.9933 10.5709 16.0613 10.5012 16.154 10.4995C16.7419 10.4793 17.3247 10.3918 17.779 9.99215C17.8539 9.91326 17.9316 9.96048 17.9633 9.98179C18.7977 10.5628 19.229 9.27694 19.4007 8.68841C19.4231 8.56863 19.4485 8.47073 19.5751 8.4644C22.6497 8.61182 28.4768 8.59109 28.4768 8.59109C28.4768 8.59109 29.2455 8.65213 29.2047 8.17474C29.1436 7.40943 25.966 7.42497 23.5923 7.75206C22.7308 7.87126 21.4801 7.93922 20.7401 7.65244C20.4332 7.53381 20.185 7.34263 20.0473 7.09904C19.8999 6.78692 19.9374 6.59977 19.9656 6.40283C20.0024 6.25886 20.0733 6.10741 20.1717 5.94674C20.7798 5.00694 22.1867 4.93439 22.6237 4.93439C22.7078 4.93439 22.7608 4.89868 22.7712 4.83706C22.8155 4.61996 22.9785 4.11839 23.5681 4.08672C23.7346 4.07578 23.9033 4.01301 24.0081 3.96521C24.0784 3.93354 24.1227 3.95197 24.11 4.01301C24.0933 4.08902 24.0576 4.19038 23.9701 4.26639C23.5561 4.62112 23.6177 4.78466 23.6666 4.83131C23.696 4.85376 23.7334 4.84282 23.7639 4.81288C25.017 3.72105 25.7472 4.44433 25.9701 4.68043C26.0063 4.72247 26.0167 4.78869 25.9441 4.80712C25.093 4.99831 24.7654 5.75786 23.0268 5.63521C22.8155 5.62138 21.392 5.54998 20.9394 6.19494C20.6791 6.56982 20.8605 6.91995 21.6287 7.08925C22.212 7.21709 23.5728 7.01957 24.2143 6.96717C24.8425 6.91534 27.5802 6.57328 29.0163 6.98617C29.6222 7.1595 30.5026 7.64726 30.327 8.56575C30.213 9.14564 29.655 9.37426 29.655 9.37426C29.655 9.37426 28.0806 10.4828 30.9063 10.4949ZM10.3545 9.07135C10.1097 8.85598 10.643 7.63516 9.46651 7.33917C9.28224 7.32823 9.54598 7.558 9.48034 7.61328C9.13828 7.89718 9.22753 8.00947 9.20738 8.17935C9.20047 8.264 9.11121 8.25536 9.06802 8.23924C8.81925 8.07109 8.19847 7.74343 7.63125 8.26918C7.52299 8.36823 7.84778 8.38781 7.83856 8.44424C7.76773 8.84101 8.02169 9.05581 8.20884 9.15658C8.26988 9.18595 8.26988 9.26196 8.23591 9.31149C8.17371 9.37829 8.02226 9.47791 7.98598 9.64203C7.96237 9.75432 7.56618 9.71113 7.68711 9.83897C8.29176 10.4765 8.91196 10.1062 9.1544 9.91729C9.32658 9.74511 10.0464 9.9432 9.93527 10.3118C9.79648 10.7799 9.83219 11.0097 9.94908 10.9268C10.1345 10.8081 10.2399 10.7258 10.4933 10.7258C10.5422 10.7258 10.6816 10.7575 10.6257 10.8703C10.5376 11.088 10.4426 11.2832 10.5296 11.5838C10.5658 11.7128 10.6539 11.6823 10.7035 11.6328C10.9937 11.2308 11.6214 11.2377 11.9272 11.4335C12.3677 11.7174 13.615 12.1142 15.2522 10.5507C15.3011 10.5052 15.304 10.3244 15.16 10.3786C14.7143 10.5542 14.2081 10.5957 13.3841 10.1747C13.3173 10.139 13 10.0261 12.9125 10.0071C11.8903 9.78887 10.8042 9.4733 10.3545 9.07135ZM24.0006 5.89722C24.0006 5.89722 24.7164 5.87303 25.1834 5.46014C25.1834 5.46014 25.685 5.28911 25.977 5.55401C26.0098 5.58511 26.0167 5.65709 25.9378 5.67091C25.8514 5.68703 25.7305 5.72389 25.5975 5.81257C25.3412 5.9836 24.3191 6.40858 24.0006 5.89722ZM16.3025 9.61036C16.2144 9.84646 15.8827 9.76757 15.7054 9.91269C15.6858 9.92939 15.6328 9.92939 15.6167 9.91729C15.4416 9.76757 15.1122 9.84128 15.0051 9.58444C14.9965 9.56429 14.9965 9.52283 15.0443 9.51534C15.2775 9.49 15.4854 9.37541 15.6363 9.20956C15.6489 9.19401 15.6892 9.17904 15.7221 9.21877C15.8586 9.3708 16.0503 9.48137 16.2628 9.51534C16.2893 9.51937 16.3267 9.54183 16.3025 9.61036ZM14.2076 5.36916C14.1402 5.30581 14.0492 5.26608 13.9496 5.26608C13.7446 5.26608 13.5787 5.4325 13.5787 5.63866C13.5787 5.75614 13.6329 5.86037 13.7164 5.93062C13.748 5.95135 13.7866 5.93753 13.7935 5.92601C13.9058 5.74635 14.0446 5.58165 14.2047 5.45151C14.2202 5.43826 14.2358 5.38989 14.2076 5.36916ZM14.4759 8.60203C14.4759 8.43618 14.1667 7.71406 14.0498 7.51884C13.8033 7.08982 14.1701 5.82869 14.7621 5.68012C14.89 5.6496 14.9545 5.46302 14.8554 5.3657C14.6084 5.11981 14.3262 4.81288 13.9502 4.81288C13.4895 4.81288 13.1175 5.18776 13.1175 5.6496C13.1175 6.17824 13.5223 6.26174 13.4941 6.40801C13.3311 6.89806 13.3288 7.43361 13.5488 7.8108C13.7014 8.07224 13.8177 8.48859 13.9087 8.78746C13.9651 9.09439 14.1506 9.35583 14.412 9.50843C14.5421 9.58444 14.4788 9.68522 14.5335 9.79463C14.5577 9.84761 14.6014 9.88159 14.6343 9.91153C14.6896 9.95415 14.6464 9.96279 14.6014 9.95645C14.2116 9.90808 13.6127 9.74396 13.3645 9.22108C13.2344 8.94121 12.8123 9.92823 12.5623 9.45661C12.2957 8.95503 12.1731 8.57842 12.055 8.07454C11.9905 7.79583 11.8149 8.27264 11.7481 8.10622C11.6266 7.7941 11.5396 7.46125 11.5396 7.10422C11.5396 5.86843 12.4472 4.83188 13.6668 4.54798C13.9024 4.49385 13.3927 4.10112 13.7256 4.11897C13.9444 4.13164 14.6596 4.13394 15.2009 4.39768C15.304 4.44202 15.3673 4.24508 15.5735 4.11378C15.589 4.10284 15.638 4.08442 15.6754 4.11263C15.8891 4.24451 15.9639 4.43627 16.067 4.39135C16.6054 4.13337 17.3143 4.13337 17.5291 4.11839C17.8746 4.09709 17.3517 4.49328 17.589 4.54741C18.8104 4.83131 19.7168 5.86785 19.7168 7.10364C19.7168 7.46125 19.6293 7.7941 19.5072 8.10564C19.4415 8.27206 19.2671 7.79525 19.2014 8.07397C19.0822 8.57784 18.9595 8.95445 18.6947 9.45603C18.4407 9.92766 18.0215 8.94006 17.8908 9.2205C17.6552 9.71747 17.1018 9.8885 16.7149 9.94839C16.6711 9.95299 16.6302 9.94724 16.6832 9.89714C16.7028 9.87756 16.796 9.79118 16.822 9.61439C16.8248 9.59596 16.8133 9.56775 16.8554 9.54989C17.1462 9.41054 17.3667 9.13988 17.4312 8.8128C17.5234 8.50932 17.6477 8.07685 17.7963 7.80965C18.1263 7.22055 17.7249 6.5059 17.828 6.34697C18.0543 6.20012 18.2052 5.94214 18.2052 5.6496C18.2052 5.18776 17.8291 4.81288 17.3708 4.81288C17.1208 4.81288 16.8974 4.92344 16.7477 5.09505L16.7241 5.11751C16.6481 5.19928 16.5732 5.28278 16.5075 5.37089C16.4315 5.46763 16.4488 5.64384 16.5789 5.67897C17.149 5.82754 17.5199 7.10998 17.2878 7.52633C17.1848 7.71118 16.8698 8.40163 16.8698 8.60261C16.8698 8.86117 16.6624 9.07078 16.4039 9.07078C16.2058 9.07078 16.0394 8.94812 15.9691 8.76615C15.9691 8.76615 15.9778 8.75118 15.9795 8.746C16.1378 8.6481 16.4839 8.43906 16.4839 8.22311L16.4154 7.51999C16.6982 7.48601 16.8294 7.33226 16.8634 7.06333C16.8893 7.04663 16.9152 7.02706 16.9371 7.00805C17.0321 6.9211 17.0943 6.68787 16.8916 6.7207C16.6031 6.77483 16.276 6.76389 15.9593 6.85199C15.9173 6.86351 15.8868 6.90094 15.8781 6.94183C15.8643 7.00287 16.0497 7.85169 16.0918 8.03942C16.0941 8.06015 16.0808 8.07397 16.0705 8.07397C15.9415 8.06245 15.7117 8.05151 15.6553 8.05151C15.6 8.05266 15.3754 8.06533 15.2418 8.07627C15.228 8.07627 15.209 8.059 15.2147 8.04172C15.2574 7.84132 15.4428 6.99769 15.4428 6.99769C15.4462 6.96141 15.4428 6.92513 15.4232 6.89576C15.3616 6.81572 14.5352 6.74604 14.4235 6.72358C14.3769 6.71494 14.3296 6.73394 14.3008 6.77253C14.2185 6.88943 14.3619 7.01957 14.4535 7.0737C14.4886 7.33399 14.6268 7.48486 14.9003 7.51884C14.9044 7.52229 14.9095 7.53151 14.913 7.53266C14.9043 7.5793 14.8341 8.22887 14.8341 8.23233C14.8341 8.45749 15.1756 8.64752 15.3455 8.74715C15.3535 8.75866 15.3662 8.77306 15.3691 8.78919C15.2867 8.95273 15.1255 9.06905 14.9401 9.06905C14.6832 9.0702 14.4759 8.86059 14.4759 8.60203ZM17.1462 5.40947C17.2999 5.54076 17.4283 5.71179 17.5354 5.90298C17.5435 5.92256 17.5844 5.94617 17.6069 5.92544C17.6892 5.85749 17.7428 5.75441 17.7428 5.63808C17.7428 5.43193 17.5769 5.2655 17.3708 5.2655C17.2884 5.2655 17.2124 5.29142 17.1519 5.33806C17.1364 5.349 17.1329 5.39737 17.1462 5.40947Z",
    fill: "#FFDD92"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2926 3.79495C35.2926 3.79495 27.0014 1.22374 19.1893 1.22144C11.3778 1.22374 3.10093 3.79034 3.08538 3.79495L2.84583 3.86751V20.0497C2.84813 29.45 9.98417 37.986 19.1858 37.9958V37.318C14.8047 37.318 10.8963 35.2737 8.07174 32.0898C5.24831 28.9064 3.52073 24.5812 3.52303 20.0497V18.1621C4.17779 18.0549 5.94682 17.7774 8.32339 17.4987C11.3472 17.1411 15.3374 16.7852 19.1887 16.7852C23.0383 16.7852 27.029 17.1416 30.0546 17.4987C32.43 17.7774 34.199 18.0555 34.8549 18.1621V20.0497C34.8549 24.5812 33.1285 28.9064 30.3062 32.0898C27.4811 35.2737 23.5727 37.318 19.1922 37.318V37.9958C28.3932 37.986 35.5304 29.45 35.5316 20.0497V3.86751L35.2926 3.79495ZM19.1887 16.108C12.4085 16.108 5.25407 17.1946 3.52303 17.4751V4.36908C3.75395 4.3017 4.14957 4.18769 4.68339 4.0466C7.3548 3.32908 13.4376 1.89807 19.1887 1.89922C23.0205 1.89922 27.0054 2.53324 30.0246 3.17014C31.5334 3.48974 32.8026 3.80762 33.6923 4.0466C34.2255 4.18769 34.6211 4.3017 34.8549 4.36908V17.4745C33.1216 17.1946 25.9706 16.108 19.1887 16.108Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSydney);
export default __webpack_public_path__ + "static/media/Sydney.2419c43c245e02fe8e41d731e27e155c.svg";
export { ForwardRef as ReactComponent };